export { default } from "./Informer.js";